import { render } from "./GroupSurveyScheduledMails.vue?vue&type=template&id=7c992e2a"
import script from "./GroupSurveyScheduledMails.vue?vue&type=script&lang=js"
export * from "./GroupSurveyScheduledMails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__